import { main } from './bootstrap';
await main();
